export const getFormattedDate = (date: string | undefined) => {
  if (date) {
    const dateToFormat = date;
    const formatted = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Stockholm",
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(dateToFormat));
    return formatted;
  }
  return;
};
